function initTransitionOverlay() {
    const variantDataEl = document.getElementById('transition-variant-data');
    if (!variantDataEl) return;
    const variantOverlays = JSON.parse(variantDataEl.textContent);
  
    let currentSrc = '';
    let lastIsFirst = false;
    let lastVariantId = null;
    let isUpdating = false;
  
    function getOverlay() {
      let overlay = document.getElementById('tinted');
      if (!overlay) {
        overlay = document.createElement('img');
        overlay.id = 'tinted';
        overlay.className = 'preview-cover tinted';
        overlay.style.display = 'none';
        overlay.alt = 'Tinted Overlay';
        variantDataEl.parentNode.insertBefore(overlay, variantDataEl.nextSibling);
      }
      return overlay;
    }
  
    function getCurrentVariantId() {
      const variantInput = document.querySelector('input[name="id"][type="hidden"]');
      if (variantInput && variantInput.value) {
        return variantInput.value;
      }
      const params = new URLSearchParams(window.location.search);
      return params.get('variant') || null;
    }
  
    function findVisibleMediaContainer() {
      const singleItem = document.querySelector('.media-viewer__item--single');
      if (singleItem && singleItem.style.display !== 'none') {
        const mediaDiv = singleItem.querySelector('.media.relative');
        if (mediaDiv) {
          return { item: singleItem, mediaDiv };
        }
      }
      
      const allItems = document.querySelectorAll('.media-viewer__item');
      for (const item of allItems) {
        if (item.style.display === 'none') continue;
        
        const mediaDiv = item.querySelector('.media.relative');
        if (mediaDiv) {
          return { item, mediaDiv };
        }
      }
      
      return null;
    }

    function updateOverlay() {
      if (isUpdating) return;
      isUpdating = true;
      
      try {
        const overlay = getOverlay();
        if (!overlay) return;

        const currentVariantId = getCurrentVariantId();
        const overlayUrl = currentVariantId ? (variantOverlays[currentVariantId] || '') : '';
    
        if (!overlayUrl) {
          overlay.src = '';
          currentSrc = '';
          overlay.style.display = 'none';
          overlay.classList.remove('animate-flicker');
          lastIsFirst = false;
          lastVariantId = currentVariantId;
          return;
        }

        const variantChanged = currentVariantId !== lastVariantId;
        lastVariantId = currentVariantId;
    
        if (overlayUrl !== currentSrc) {
          overlay.src = overlayUrl;
          currentSrc = overlayUrl;
        }

        const result = findVisibleMediaContainer();
        
        if (!result) {
          overlay.style.display = 'none';
          return;
        }

        const { mediaDiv: currentMediaDiv } = result;
        
        if (overlay.parentNode !== currentMediaDiv) {
          if (overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
          }
          
          overlay.style.position = 'absolute';
          overlay.style.top = '0';
          overlay.style.left = '0';
          overlay.style.width = '100%';
          overlay.style.height = '100%';
          overlay.style.zIndex = '9999';
          overlay.style.pointerEvents = 'none';
          
          currentMediaDiv.appendChild(overlay);
          
          const zoomLink = currentMediaDiv.querySelector('.media--zoom, .js-zoom-link');
          if (zoomLink) {
            zoomLink.classList.remove('media--zoom');
            zoomLink.style.pointerEvents = 'none';
            zoomLink.removeAttribute('href');
          }
          const zoomImg = currentMediaDiv.querySelector('.zoom-image, .js-zoom-image');
          if (zoomImg) {
            zoomImg.style.display = 'none';
          }
        }

        overlay.style.display = 'block';
        
        const zoomLink = currentMediaDiv.querySelector('.media--zoom, .js-zoom-link');
        if (zoomLink) {
          zoomLink.classList.remove('media--zoom');
          zoomLink.style.pointerEvents = 'none';
        }
        const zoomImg = currentMediaDiv.querySelector('.zoom-image, .js-zoom-image');
        if (zoomImg) {
          zoomImg.style.display = 'none';
        }
    
        const isFirst = isFirstImageActive();
        
        if (variantChanged || isFirst !== lastIsFirst) {
          if (isFirst) {
            overlay.classList.remove('animate-flicker');
            overlay.style.removeProperty('opacity');
            void overlay.offsetHeight;
            overlay.classList.add('animate-flicker');
          } else {
            overlay.classList.remove('animate-flicker');
            overlay.style.opacity = '0';
          }
          lastIsFirst = isFirst;
        }
      } finally {
        isUpdating = false;
      }
    }
  
    function isFirstImageActive() {
      const statusDiv = document.querySelector('.media-gallery__status');
      if (!statusDiv) return true;
      const text = statusDiv.textContent.trim();
      return text === '' || text.startsWith('Image 1');
    }
  
    let updateTimeout = null;
    function scheduleUpdate(delay = 100) {
      if (updateTimeout) clearTimeout(updateTimeout);
      updateTimeout = setTimeout(updateOverlay, delay);
    }

    setTimeout(updateOverlay, 500);
  
    const variantInput = document.querySelector('input[name="id"][type="hidden"]');
    if (variantInput) {
      const inputObserver = new MutationObserver(() => {
        scheduleUpdate(300);
        scheduleUpdate(600);
        scheduleUpdate(1000);
      });
      inputObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      
      if (variantInput.parentNode) {
        const parentObserver = new MutationObserver(() => {
          scheduleUpdate(300);
        });
        parentObserver.observe(variantInput.parentNode, { childList: true, subtree: true });
      }
    }
  
    const statusDiv = document.querySelector('.media-gallery__status');
    if (statusDiv) {
      const statusObserver = new MutationObserver(() => {
        scheduleUpdate(50);
      });
      statusObserver.observe(statusDiv, { childList: true, subtree: true, characterData: true });
    }
  
    document.addEventListener('click', (e) => {
      if (e.target.closest('.opt-btn, .opt-label, label[for*="option"], .variant-input, .swatch')) {
        scheduleUpdate(300);
        scheduleUpdate(600);
        scheduleUpdate(1000);
      }
    });
  
    document.addEventListener('change', (e) => {
      if (e.target.matches('[name="id"], input[type="radio"][name*="option"]')) {
        scheduleUpdate(300);
        scheduleUpdate(600);
      }
    });

    window.addEventListener('popstate', () => scheduleUpdate(300));
    
    const originalReplaceState = history.replaceState;
    history.replaceState = function(...args) {
      originalReplaceState.apply(this, args);
      scheduleUpdate(300);
    };
  }

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransitionOverlay);
} else {
    initTransitionOverlay();
}
